import { ROUTE_NAMES_RAPIDBOARD_BACKLOG } from '@atlassian/jira-common-constants/src/spa-routes.tsx';
import type { InvariantRoute } from '@atlassian/react-resource-router/src/common/types';

export const rapidboardBacklog1Route: InvariantRoute = {
	name: ROUTE_NAMES_RAPIDBOARD_BACKLOG,
	path: '/secure/RapidBoard.jspa',
	query: ['rapidView', 'view=(planning|planning.nodetail)'],
};
